import './source_view.js.coffee'
Namespace 'Settings.Views.Topics'

class Settings.Views.Topics.ReclameaquiSourceView extends Settings.Views.Topics.SourceView
  id: 'new_reclameaqui_source'
  type: Monitoring.Models.SocialContents.ClaimMessage.TYPE
  icon: image_path('source_ra.png')
  channelViewClass: Settings.Views.Topics.ReclameaquiChannelView
